import React from "react";
import { motion } from "framer-motion";

const pillars = [
  { t: "Equilíbrio Emocional", d: "Estudar com clareza começa por estar bem por dentro." },
  { t: "Confiança", d: "Acreditar em si mesmo é o primeiro passo para qualquer conquista." },
  { t: "Motivação", d: "Encontrar o porquê que move cada aluno todos os dias." },
  { t: "Autoestima", d: "Reconhecer o valor próprio e o caminho percorrido." },
  { t: "Disciplina", d: "Hábitos consistentes que constroem resultados duradouros." },
  { t: "Autonomia", d: "Aprender a aprender — preparado para a vida." },
  { t: "Crescimento Pessoal", d: "Cada desafio é uma oportunidade de evoluir." },
  { t: "Desenvolvimento Humano", d: "Formar pessoas inteiras, não apenas alunos brilhantes." },
];

export const Philosophy = () => {
  return (
    <section id="filosofia" data-testid="philosophy-section" className="section bg-stone-50">
      <div className="container-tight">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5 lg:sticky lg:top-28"
          >
            <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-bordeaux-700 mb-4">Filosofia do Centro</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-stone-900 leading-tight">
              Acompanhamos o aluno, <span className="italic text-bordeaux-700">não apenas a matéria.</span>
            </h2>
            <p className="mt-5 text-stone-600 leading-relaxed">
              No iLg, acreditamos que aprender vai muito além das notas. Cuidamos do desempenho académico
              e do equilíbrio emocional — porque um aluno feliz é um aluno que cresce.
            </p>

            <div className="mt-8 rounded-2xl overflow-hidden aspect-[4/3] shadow-[0_30px_60px_rgba(0,0,0,0.12)]">
              <img
                src="https://images.pexels.com/photos/5905858/pexels-photo-5905858.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=900"
                alt="Alunos a desenvolver competências e crescimento pessoal"
                className="h-full w-full object-cover"
              />
            </div>
          </motion.div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {pillars.map((p, i) => (
              <motion.div
                key={p.t}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`philosophy-card-${i}`}
                className="p-6 rounded-2xl bg-white border border-stone-100 hover:border-bordeaux-200 hover:-translate-y-1 transition-all hover:shadow-[0_20px_40px_rgba(0,0,0,0.05)]"
              >
                <div className="font-display text-2xl text-bordeaux-700">{p.t}</div>
                <p className="mt-2 text-stone-600 text-sm leading-relaxed">{p.d}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
